module.exports = __webpack_public_path__ + "static/media/JTWT-BNB.7f6a651e.svg";